













import Radio from '@/packages/m-radio';
import Vue from 'vue';
import Component from 'vue-class-component';

Vue.use(Radio);
@Component({
  name: 'Components'
})
export default class Components extends Vue {

  public value = null;
  public value2 = null;

  get options() {
    const options = [];
    for (let i = 0; i < 100; i++) {
      options.push({label: '选项' + i, value: i});
    }
    return options;
  }

  get options2() {
    const options = [];
    for (let i = 0; i < 5; i++) {
      options.push({label: '选项' + i, value: i});
    }
    return options;
  }
}
